/**
 * Automatically set key in context by renderer in cli.mts and createHtmlTemplate.ts
 * Contains menu items
 */
export const menuContextKey = "menu";
